import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class BankService {
  getAllBankAccountsByManager(idUser) {
    return api.get(
      UtilsUrl.BankPosURL() + "/getAllBankAccountsByManager/" + idUser
    );
  }
  getAllCaissesByManager(idUser) {
    return api.get(UtilsUrl.BankPosURL() + "/getAllCaissesByManager/" + idUser);
  }

  searchPayementByRef(idUser,typePayement,ref) {
    return api.get(UtilsUrl.PayementPosURL() + "/searchPayementByRef/" + idUser+"/"+typePayement+"/"+ref);
  }
}
export default new BankService();
